import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=04122d2c&scoped=true&"
import script from "./Background.vue?vue&type=script&lang=ts&"
export * from "./Background.vue?vue&type=script&lang=ts&"
import style0 from "./Background.vue?vue&type=style&index=0&id=04122d2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04122d2c",
  null
  
)

export default component.exports